import { ITransformItem } from "@kuika/kuika-cl-model";
import classNames from "classnames";
import React from "react";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";

export interface TransformRowProps {
  item: ITransformItem;
  index: number;
  isActive: boolean;
  summary: string;
  onSelect: (index: number) => void;
  onRemove: (index: number) => void;
  dataTestId?: string;
}

// Icon names map to /designer/public/images/common/*.svg. Some Faz 3 visuals
// don't yet have first-class artwork (skew especially); we fall back to the
// closest existing common icons. Dedicated icons can be swapped in without
// touching the component logic.
const TYPE_ICON: Record<string, string> = {
  move: "arrows-horizontal",
  scale: "maximize",
  rotate: "rotate-2",
  skew: "dots-vertical"
};

const TransformRow: React.FC<TransformRowProps> = ({
  item,
  index,
  isActive,
  summary,
  onSelect,
  onRemove,
  dataTestId
}) => {
  const iconName: string = TYPE_ICON[item.type] ?? "dots-vertical";

  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={isActive}
      className={classNames("transform-row", { "transform-row--active": isActive })}
      onClick={(): void => onSelect(index)}
      onKeyDown={(e: React.KeyboardEvent): void => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(index);
        }
      }}
      data-testid={dataTestId}
    >
      <span className="transform-row__icon">
        <KuikaSvg name={iconName} width={14} height={14} />
      </span>
      <span className="transform-row__summary">{summary}</span>
      <button
        type="button"
        aria-label="Remove transform"
        className="transform-row__trash"
        onClick={(e: React.MouseEvent): void => {
          e.stopPropagation();
          onRemove(index);
        }}
        data-testid={dataTestId ? `${dataTestId}-remove` : undefined}
      >
        <KuikaSvg name="trash" width={14} height={14} />
      </button>
    </div>
  );
};

export default TransformRow;
